import en from './en.json';
import fr from './fr.json';

export default {
  // NOTE: i18next requires each locale to be wrapped in `translation`
  'en-CA': { translation: en },
  'fr-CA': { translation: fr },
};
